<template>
  <div>
    <div class="row wrapper border-bottom white-bg page-heading">
      <div class="col-xs-12">
        <h2>{{ $t('dashboard') }}</h2>
        <ol class="breadcrumb">
          <li class="active">
            <strong>{{ $t('dashboard') }}</strong>
          </li>
        </ol>
        <!-- <button class="btn btn-white btn-lg help-breadcrumb" @click="help" data-toggle="tooltip" data-placement="bottom" title="Ajuda"><i class="fa fa-question help-button"></i></button> -->
        <img :src="logo" class="logo-instituicao" />
      </div>
    </div>
    <div class="wrapper wrapper-content animated fadeInDown">
      <div class="row">
        <div class="col-md-12">
          <div class="tabs-container m-b-sm">
            <ul class="nav nav-tabs">
              <li
                v-for="(tab, index) in tabs"
                :id="`tab-header-${index}`"
                :key="index"
              >
                <a
                  data-toggle="tab"
                  :href="`#${index}`"
                  @click="requestTabData(tab)"
                >
                  {{ tab.nome }}
                </a>
              </li>
            </ul>
            <div class="tab-content">
              <div
                v-for="(tab, index) in tabs"
                :id="index"
                :key="index"
                class="tab-pane"
              >
                <div class="panel-body">
                  <h4>{{ $t('dashboard_view.decision_panel') }}</h4>
                  <br />
                  <h5>{{ $t('dashboard_view.range') }}</h5>
                  <div :id="`periodo-selection-${index}`" class="btn-group m-b">
                    <a
                      v-if="tab.diario"
                      class="btn btn-white btn-xs"
                      :class="{ active: tab.frequencia === 1 }"
                      @click="selectFrequencia(tab, 1)"
                    >
                      {{ $t('daily') }}
                    </a>
                    <a
                      v-if="tab.semanal"
                      class="btn btn-white btn-xs"
                      :class="{ active: tab.frequencia === 2 }"
                      @click="selectFrequencia(tab, 2)"
                    >
                      {{ $t('weekly') }}
                    </a>
                    <a
                      v-if="tab.mensal"
                      class="btn btn-white btn-xs"
                      :class="{ active: tab.frequencia === 3 }"
                      @click="selectFrequencia(tab, 3)"
                    >
                      {{ $t('monthly') }}
                    </a>
                    <a
                      v-if="tab.anual"
                      class="btn btn-white btn-xs"
                      :class="{ active: tab.frequencia === 5 }"
                      @click="selectFrequencia(tab, 5)"
                    >
                      {{ $t('yearly') }}
                    </a>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="wrapper-table">
                        <table class="table table-striped">
                          <thead>
                            <tr>
                              <th class="th-check" />
                              <th>{{ $t('name') }}</th>
                              <th class="text-center">{{ $t('unit') }}</th>
                              <th class="text-right">
                                {{ $t('dashboard_view.actual_value') }}
                              </th>
                              <th class="text-right">
                                {{ $t('dashboard_view.previous_value') }}
                              </th>
                              <th class="text-right">
                                {{ $t('dashboard_view.last_year') }}
                              </th>
                              <th class="text-right th-var">
                                {{ $t('variation') }} (%)
                              </th>
                              <th class="text-right th-var">
                                {{ $t('dashboard_view.yearly_var') }} (%)
                              </th>
                            </tr>
                          </thead>
                          <tbody :id="`table-${index}`">
                            <tr
                              v-for="(item, itemIndex) in tab.items"
                              :key="itemIndex"
                            >
                              <td>
                                <input
                                  v-model="item.check"
                                  type="checkbox"
                                  @click="check(item)"
                                />
                              </td>
                              <td>{{ item.Nome || '-' }}</td>
                              <td class="text-center">
                                {{ item.UnidadeSigla || '-' }}
                              </td>
                              <td class="text-right">
                                {{ formatNumber(item.ValorAtual) }}
                              </td>
                              <td class="text-right">
                                {{ formatNumber(item.ValorAnterior) }}
                              </td>
                              <td class="text-right">
                                {{ formatNumber(item.ValorAnoAnterior) }}
                              </td>
                              <td class="text-right">
                                <span
                                  class="variacao"
                                  :class="{
                                    'variacao-positiva':
                                      item.VariacaoAnterior > 0,
                                    'variacao-negativa':
                                      item.VariacaoAnterior < 0
                                  }"
                                >
                                  {{ formatNumber(item.VariacaoAnterior) }}
                                </span>
                              </td>
                              <td class="text-right">
                                <span
                                  class="variacao"
                                  :class="{
                                    'variacao-positiva':
                                      item.VariacaoAnoAnterior > 0,
                                    'variacao-negativa':
                                      item.VariacaoAnoAnterior < 0
                                  }"
                                >
                                  {{ formatNumber(item.VariacaoAnoAnterior) }}
                                </span>
                              </td>
                            </tr>
                            <tr v-if="tab.items.length === 0">
                              <td colspan="8">{{ $t('no_item_found') }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="graphData.length > 0" class="col-md-12">
          <div class="ibox">
            <div class="ibox-title">
              <h5>{{ $t('graph') }}</h5>
            </div>
            <div class="ibox-content">
              <div id="dashboard-graph">
                <chart
                  v-if="redrawChart"
                  :data="graphData"
                  :options="graphOptionsComputed"
                  type="AreaChart"
                  :filter="graphFilter"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable vue/no-side-effects-in-computed-properties */
import $ from 'jquery'
import hopscotch from 'hopscotch'
import { Chart } from '../../shared'
import store from '../../store'
import { baseSteps } from '../../lib/tour'
import { remove } from 'lodash'
import { mapGetters, mapActions } from 'vuex'
import hideLoading from '../../lib/hideLoading'

function exibeDashboard() {
  const data = window.localStorage.getItem('imea.portal.userinfo')
  if (data) {
    const obj = JSON.parse(data)
    return obj ? obj.ExibeDashboard : ''
  }
}

export default {
  name: 'Dashboard',
  components: {
    Chart
  },
  beforeRouteEnter(to, from, next) {
    if (!exibeDashboard()) {
      next({ name: 'serie-index' })
    }
    Promise.all([
      store.dispatch('ping/requestData'),
      store.dispatch('dashboard/clearGraph'),
      store.dispatch('dashboard/requestData')
    ]).then(() => next())
  },
  beforeRouteLeave(to, from, next) {
    hopscotch.endTour(true)
    next()
  },
  created() {
    document.title = 'Dashboard - IMEA'
    this.$analytics.setCurrentScreen(document.title)
    this.$analytics.logEvent('screen_view')

    if (this.tabs.length > 0) {
      const tab = this.tabs[0]
      this.clearGraph()

      let frequencia = 1
      if (tab.diario) {
        frequencia = 1
      } else if (tab.semanal) {
        frequencia = 2
      } else if (tab.mensal) {
        frequencia = 3
      } else if (tab.anual) {
        frequencia = 5
      }

      this.loadData({ cadeia: tab.cadeia, frequencia }).then(() => {
        tab.frequencia = frequencia
        tab.items.forEach((item, index) => {
          if (index === 0) {
            item.check = true
            this.enqueue(item)
          }
        })
      })
    }
    const str = window.localStorage.getItem('imea.portal.instituicao')
    if (str) {
      const data = JSON.parse(str)
      if (data) {
        this.logo = data.Logo
      }
    }
  },
  mounted() {
    $('.nav-tabs a:first').tab('show')
    window.addEventListener('resize', this.refreshChart)
    if (!localStorage.tour) {
      this.help()
      localStorage.tour = true
    }
    hideLoading()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.refreshChart)
  },
  computed: {
    isUnitsEqual() {
      return this.queue
        .map(item => item.UnidadeSigla)
        .every((val, i, arr) => val === arr[0])
    },
    maxGraphValue() {
      if (!this.graphData.length || !this.isUnitsEqual) return

      const flatData = this.graphData[0].rows
        .map(item => {
          if (item.length === 3) return [item[1], item[2]]
          return item[1]
        })
        .flat()

      return Math.max(...flatData)
    },
    minGraphValue() {
      if (!this.graphData.length || !this.isUnitsEqual) return

      const flatData = this.graphData[0].rows
        .map(item => {
          if (item.length === 3) return [item[1], item[2]]
          return item[1]
        })
        .flat()

      return Math.min(...flatData.filter(n => n))
    },
    graphData() {
      const array = []
      if (this.graph.length > 0) {
        const columns = this.graph[0].map((item, index) => {
          if (index === 1) {
            this.graphOptions.vAxes['0'].title = item
          }
          if (index === 2 && item !== 'tooltip') {
            this.graphOptions.vAxes['1'].title = item
          } else if (index === 3 && item != 'tooltip') {
            this.graphOptions.vAxes['1'].title = item
          }
          if (item === 'Date') return { id: 'Data', type: 'date' }
          if (item === 'tooltip') return { id: 'tooltip' }
          return { id: item, type: 'number' }
        })

        const rows = this.graph.slice(1)
        array.push({ columns, rows })
      }
      return array
    },
    graphOptionsComputed() {
      const options = { ...this.graphOptions }

      options.vAxis.maxValue = this.maxGraphValue
      options.vAxis.minValue = this.minGraphValue
      return options
    },
    ...mapGetters('dashboard', ['tabs', 'graph'])
  },
  methods: {
    help() {
      hopscotch.startTour(this.tour)
    },
    refreshChart() {
      this.redrawChart = false
      clearTimeout(this.resizeTimer)
      this.resizeTimer = setTimeout(() => {
        this.redrawChart = true
      }, 200)
    },
    selectFrequencia(tab, frequencia) {
      if (tab.frequencia !== frequencia) {
        this.requestTabData(tab, frequencia)
      }
    },
    requestTabData(tab, frequencia) {
      const index = this.tabs.indexOf(tab)
      const steps = this.tour.steps.filter(step => step.tab)
      steps.forEach(step => {
        const text = step.target.slice(0, -2)
        step.target = `${text}-${index}`
      })

      if (!frequencia) {
        if (tab.diario) {
          frequencia = 1
        } else if (tab.semanal) {
          frequencia = 2
        } else if (tab.mensal) {
          frequencia = 3
        } else if (tab.anual) {
          frequencia = 5
        }
      }

      const { cadeia } = tab
      tab.frequencia = frequencia
      this.queue = []
      this.clearGraph()
      this.loadData({ cadeia, frequencia }).then(() => {
        tab.items.forEach((item, index) => {
          if (index === 0) {
            item.check = true
            this.enqueue(item)
          }
        })
      })
    },
    formatNumber(value) {
      if (!value) return '-'

      return new Intl.NumberFormat(this.$i18n.locale, {
        maximumFractionDigits: 2
      }).format(value)
    },
    check(item) {
      if (!item.check) {
        this.enqueue(item)
      } else {
        remove(this.queue, i => i.Id === item.Id)
        const params = this.getGraphParams()
        this.requestGraphData(params)
      }
    },
    enqueue(item) {
      if (this.queue.length < 2) {
        this.queue.push(item)
      } else {
        this.queue.shift().check = false
        this.queue.push(item)
      }
      const params = this.getGraphParams()
      this.requestGraphData(params)
    },
    getGraphParams() {
      const list = this.queue.map(i => i.Id)
      let configuracao1
      let configuracao2
      list.forEach((item, index) => {
        if (index === 0) {
          configuracao1 = item
        }
        if (index === 1) {
          configuracao2 = item
        }
      })
      return { configuracao1, configuracao2 }
    },
    ...mapActions('dashboard', ['loadData', 'requestGraphData', 'clearGraph'])
  },
  data() {
    return {
      tour: {
        id: 'dashboard-tour',
        showPrevButton: true,
        i18n: {
          nextBtn: this.$t('tour_next'),
          prevBtn: this.$t('tour_prev'),
          doneBtn: this.$t('tour_done'),
          skipBtn: this.$t('tour_skip'),
          closeTooltip: this.$t('tour_close'),
          stepNums: ['1', '2', '3']
        },
        steps: baseSteps.concat([
          {
            title: this.$t('dashboard_view.tour[0].title'),
            content: this.$t('dashboard_view.tour[0].content'),
            target: 'tab-header-0',
            placement: 'bottom',
            xOffset: 10
          },
          {
            tab: true,
            title: this.$t('dashboard_view.tour[1].title'),
            content: this.$t('dashboard_view.tour[1].content'),
            target: 'periodo-selection-0',
            placement: 'bottom'
          },
          {
            tab: true,
            title: this.$t('dashboard_view.tour[2].title'),
            content: this.$t('dashboard_view.tour[2].content'),
            target: 'table-0',
            placement: 'bottom',
            yOffset: -25
          },
          {
            title: this.$t('dashboard_view.tour[3].title'),
            content: this.$t('dashboard_view.tour[3].content'),
            target: 'dashboard-graph',
            placement: 'top',
            xOffset: 200,
            yOffset: 100
          },
          {
            title: this.$t('dashboard_view.tour[4].title'),
            content: this.$t('dashboard_view.tour[4].content'),
            target: 'filter_div',
            placement: 'top',
            xOffset: 120
          }
        ])
      },
      resizeTimer: '',
      redrawChart: true,
      logo: '',
      queue: [],
      graphOptions: {
        chartArea: { width: '90%', height: '95%' },
        tooltip: { isHtml: true },
        height: 400,
        legend: { position: 'bottom' },
        pointSize: 0,
        interpolateNulls: true,
        fontSize: 12,
        hAxis: {
          gridlines: {
            color: 'transparent'
          },
          format: this.$i18n.locale === 'en' ? 'MM/dd/y' : 'dd/MM/y',
          textStyle: { bold: true }
        },
        vAxis: {
          gridlines: {
            color: 'transparent'
          }
        },
        vAxes: {
          0: {
            title: 'Milho em algum lugar',
            titleTextStyle: { color: '#14ab65', bold: false },
            textStyle: { color: '#14ab65', bold: false }
          },
          1: {
            title: 'Serie 2',
            titleTextStyle: { color: '#2b9ac5', bold: false },
            textStyle: { color: '#2b9ac5', bold: false }
          }
        },
        series: {
          0: { targetAxisIndex: 0, color: '#14ab65' },
          1: { targetAxisIndex: 1, color: '#2b9ac5' }
        },
        animation: {
          duration: 200,
          easing: 'out'
        }
      },
      graphFilter: {
        controlType: 'ChartRangeFilter',
        containerId: 'filter_div',
        options: {
          chartArea: { width: '90%', height: '95%' },
          filterColumnIndex: 0,
          ui: {
            chartType: 'LineChart',
            chartOptions: {
              interpolateNulls: true,
              pointSize: 0,
              fontSize: 12,
              height: 80,
              legend: { position: 'none' },
              hAxis: {
                textPosition: 'in',
                format: 'MMM yyyy',
                textStyle: { bold: true }
              },
              series: {
                '0': { targetAxisIndex: 0, color: '#14ab65' },
                '1': { targetAxisIndex: 1, color: '#2b9ac5' }
              }
            },
            minRangeSize: 432000000
          }
        },
        state: {
          range: {
            start: new Date(-8640000000000000), // data mínima
            end: new Date()
          }
        }
      }
    }
  }
}
</script>
